var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "manualResponseModal",
    attrs: { id: "manual-response-modal", "modal-dialog-size": "xl" },
    on: { show: _vm.initLoanDecision, hide: _vm.clearData },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("direct-to-lender.lenderSubmit.composeManualResponse")
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("h2", { staticClass: "section-separator-title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("direct-to-lender.lenderSubmit.lenderInformation")
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-3" },
              [
                _c(
                  "lender-information",
                  _vm._b(
                    {
                      on: { validation: _vm.lenderInformationValidationChange },
                    },
                    "lender-information",
                    _vm.lenderInformationProps,
                    false
                  )
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isDecisionAccepted
              ? [
                  _c("h2", { staticClass: "section-separator-title" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "direct-to-lender.lenderSubmit.responseDetails"
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("response-details-block", {
                        attrs: {
                          "submitted-application-id":
                            _vm.currentSubmittedApplicationId,
                        },
                        on: { validation: _vm.responseDetailsValidationChange },
                      }),
                    ],
                    1
                  ),
                ]
              : [
                  _c(
                    "h2",
                    { staticClass: "section-separator-title" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "direct-to-lender.lenderSubmit.declineReason"
                            )
                          )
                      ),
                      _c("input-required-indicator"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-3" },
                    [
                      _c("decline-reason-block", {
                        attrs: {
                          "submitted-application-id":
                            _vm.currentSubmittedApplicationId,
                        },
                        on: { validation: _vm.declineReasonValidationChange },
                      }),
                    ],
                    1
                  ),
                ],
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "b-button",
              {
                staticClass: "validation-button",
                attrs: {
                  variant: "primary",
                  size: "sm",
                  disabled:
                    !_vm.isResponseValid || _vm.submittingManualResponse,
                },
                on: { click: _vm.submitManualResponse },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.words.submit")) +
                    "\n      "
                ),
                _c(
                  "span",
                  { staticClass: "validation-icon" },
                  [
                    _vm.submittingManualResponse
                      ? _c("inline-loader", { attrs: { variant: "secondary" } })
                      : _c("i", {
                          staticClass: "fa",
                          class: _vm.validButtonIcon,
                          attrs: { "aria-hidden": "true" },
                        }),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }